export default "__VITE_ASSET__BnOcbqrV__"